<template>
  <div class="form-group">
      <label style="display: block">{{ name }}</label>
      <el-select v-model="data[id]" v-bind:multiple="multiple" filterable clearable>
<!--          <el-option v-if="!notNull" :value="null">...</el-option>-->
          <el-option :label="o.name" :key="o.id" :value="o.id" v-for="o in options"></el-option>
      </el-select>
  </div>
</template>

<script>
    export default {
        props: {
            id: String,
            name: String,
            data: Object,
            options: Array,
            notNull: Boolean,
            multiple: Boolean,
        },
        data() {
            return {
            };
        },
        computed: {
        },
        methods: {
        },
        created() {
            if (!this.data[this.id]) {
                this.$set(this.data, this.id, null);
            }
        }
    }
</script>